/** Shared MGA period attachment kinds (keep in sync with Prisma MgaAttachmentKind). */
export type MgaAttachmentKind = 'CLOSE_PACK' | 'CASH_VOUCHER' | 'BONDED_RECEIPT' | 'OTHER';

export const MGA_ATTACHMENT_KIND_OPTIONS: Array<{ value: MgaAttachmentKind; label: string }> = [
  { value: 'CLOSE_PACK', label: 'Signed close pack' },
  { value: 'CASH_VOUCHER', label: 'Cash voucher' },
  { value: 'BONDED_RECEIPT', label: 'Bonded receipt' },
  { value: 'OTHER', label: 'Other' },
];

export function mgaAttachmentKindLabel(kind: string | null | undefined): string {
  const hit = MGA_ATTACHMENT_KIND_OPTIONS.find((o) => o.value === kind);
  return hit?.label ?? 'Other';
}

export function parseMgaAttachmentKind(raw: unknown): MgaAttachmentKind {
  const v = String(raw ?? '').trim().toUpperCase();
  if (v === 'CLOSE_PACK' || v === 'CASH_VOUCHER' || v === 'BONDED_RECEIPT' || v === 'OTHER') {
    return v;
  }
  return 'OTHER';
}
